<template lang="html">
  <root class="admin-dashboard">

    <admin-nav></admin-nav>

    <!-- Content -->
    <content>
      <h1>Welcome to Awani admin panel</h1>
      <p>You can manage users, businesses, dishes and orders from here</p>
    </content>

    <!-- Counters -->
    <section class="container" v-if="counter.users">
      <div class="row">
        <div class="col m4 offset-m4">
          <i class="material-icons">group</i>
          <h4>{{ counter.users.count }} <small>Users</small></h4>
        </div>
      </div>

      <div class="row">

        <div class="col m3">
          <i class="material-icons">restaurant</i>
          <h4>{{ counter.businesses.count }} <small>Businesses</small></h4>
        </div>

        <div class="col m3">
          <i class="material-icons">restaurant_menu</i>
          <h4>{{ counter.dishes.count }} <small>Dishes</small></h4>
        </div>

        <div class="col m3">
          <i class="material-icons">whatshot</i>
          <h4>{{ counter.instant_dishes.count }} <small>Instant dishes</small></h4>
        </div>

        <div class="col m3">
          <i class="material-icons">shopping_cart</i>
          <h4>{{ counter.orders.count }} <small>Orders</small></h4>
        </div>
      </div>

    </section>

    <preloader :is-active="!counter.users"></preloader>

  </root>
</template>

<script>
import * as firebase from "firebase";
import pageState from "../../plugins/page-state";
import _ from "lodash";

export default {
  data: () => {
    return {
      counter: {
        users: { count: 0, timestamp: null },
        businesses: { count: 0, timestamp: null },
        dishes: { count: 0, timestamp: null },
        instant_dishes: { count: 0, timestamp: null },
        orders: { count: 0, timestamp: null },
        verifications: { count: 0, timestamp: null },
      },
    };
  },

  methods: {
    // Reset counters
    resetCounters() {
      _.forEach(this.counter, (value, counter) => {
        this.counter[counter] = 0;
      });
    },

    // Collect dashboard
    collectDashboard() {
      this.resetCounters();

      firebase
        .database()
        .ref("dashboard")
        .once("value")
        .then((dashboardSnap) => {
          let dashboard = dashboardSnap.val();

          // Bind
          this.$nextTick(() => {
            this.counter.users = dashboard.users;
            this.counter.businesses = dashboard.businesses;
            this.counter.dishes = dashboard.dishes;
            this.counter.instant_dishes = dashboard.instant_dishes;
            this.counter.orders = dashboard.orders;
            this.counter.verifications = dashboard.verifications;

            pageState.setItem("Dashboard", this.counter);
          });
        });
    },

    // Calculate counters
    calculateCounters() {
      //this.resetCounters();

      let counter = {
        users: { count: 0, timestamp: null },
        businesses: { count: 0, timestamp: null },
        dishes: { count: 0, timestamp: null },
        instant_dishes: { count: 0, timestamp: null },
        orders: { count: 0, timestamp: null },
        verifications: { count: 0, timestamp: null },
      };

      //Count Users
      firebase
        .database()
        .ref("users")
        .on("value", (itemsSnap) => {
          counter.users.count = itemsSnap.numChildren();
          counter.users.timestamp = firebase.database.ServerValue.TIMESTAMP;
          firebase.database().ref("dashboard/users").update(counter.users);
        });

      //Count Businesses
      firebase
        .database()
        .ref("businesses")
        .on("value", (itemsSnap) => {
          counter.businesses.count = itemsSnap.numChildren();
          counter.businesses.timestamp =
            firebase.database.ServerValue.TIMESTAMP;
          firebase
            .database()
            .ref("dashboard/businesses")
            .update(counter.businesses);
        });

      //Count Dishes
      firebase
        .database()
        .ref("dishes")
        .on("value", (itemsSnap) => {
          counter.dishes.count = itemsSnap.numChildren();
          counter.dishes.timestamp = firebase.database.ServerValue.TIMESTAMP;
          firebase.database().ref("dashboard/dishes").update(counter.dishes);
        });

      //Count Instant Dishes
      firebase
        .database()
        .ref("dishes")
        .orderByChild("is_instant")
        .equalTo(true)
        .on("value", (itemsSnap) => {
          counter.instant_dishes.count = itemsSnap.numChildren();
          counter.instant_dishes.timestamp =
            firebase.database.ServerValue.TIMESTAMP;
          firebase
            .database()
            .ref("dashboard/instant_dishes")
            .update(counter.instant_dishes);
        });

      //Count Orders
      firebase
        .database()
        .ref("orders")
        .on("value", (itemsSnap) => {
          counter.orders.count = itemsSnap.numChildren();
          counter.orders.timestamp = firebase.database.ServerValue.TIMESTAMP;
          firebase.database().ref("dashboard/orders").update(counter.orders);
        });

      //Count Verifications
      firebase
        .database()
        .ref("verifications")
        .on("value", (itemsSnap) => {
          counter.verifications.count = itemsSnap.numChildren();
          counter.verifications.timestamp =
            firebase.database.ServerValue.TIMESTAMP;
          firebase
            .database()
            .ref("dashboard/verifications")
            .update(counter.verifications);
        });

      this.counter = counter;
    },

    calculateBusinessPerformance() {
      firebase
        .database()
        .ref("businesses")
        .orderByChild("is_archived")
        .equalTo(false)
        .once("value")
        .then((businessesSnap) => {
          let businesses = businessesSnap.val();
          //var businessesLength = _.size(businesses);
          //console.log("Businesses Count: " + businessesLength);

          _.forEach(businesses, (business, businessKey) => {
            /* Sorting based on ratings count hight to low and rate average high to low */
            var businessCompletedOrders = [];

            firebase
              .database()
              .ref("orders")
              .orderByChild("business/key")
              .equalTo(businessKey)
              .once("value")
              .then((ordersSnap) => {
                let orders = ordersSnap.val();

                //Completed Orders
                _.forEach(orders, (order) => {
                  let isCompletedOrder = _.isMatch(order, {
                    status: "completed",
                  });
                  if (isCompletedOrder) businessCompletedOrders.push(order);
                });
                business["completed_orders"] = _.size(businessCompletedOrders);

                //Ratings
                var ratings = _.map(business.ratings, (rating) => rating);
                var ratingAvg = _.round(
                  _.divide(_.sumBy(ratings, "rate"), _.size(ratings) * 3)
                );
                business["rating_avg"] = _.isNaN(ratingAvg) ? 0 : ratingAvg;

                //Update Business
                firebase
                  .database()
                  .ref("businesses/" + businessKey)
                  .update(business);

                // Console message
                //console.log("Update Business: " + businessKey + " " + JSON.stringify(business));

              });

            //Get dish types available
            firebase
              .database()
              .ref("dishes")
              .orderByChild("business_key")
              .equalTo(businessKey)
              .once("value")
              .then((dishesSnap) => {
                let dishes = dishesSnap.val();

                let dishTypes = [];

                _.forEach(dishes, (dish) => {
                  if (dishTypes.indexOf(dish.type) == -1) {
                    dishTypes.push(dish.type);
                  }
                });
                business["dish_types_available"] = dishTypes;

                //Update Business
                firebase
                  .database()
                  .ref("businesses/" + businessKey)
                  .update(business);

                // Console message
                //console.log("Update Business dish Types Available: " + businessKey + " " + JSON.stringify(dishTypes));

              });
          });
        });
    },
  },

  // Mounted
  mounted() {
    this.collectDashboard();
    this.calculateCounters();

    let businessPerformanceDate = pageState.getItemObject("BusinessPerformanceDate");

    //console.log("BusinessPerformanceDate: " + businessPerformanceDate);

    var today = new Date();

    if (businessPerformanceDate == undefined || businessPerformanceDate + 7 <= today) {
      pageState.setItem("BusinessPerformanceDate", today);
      this.calculateBusinessPerformance();
    }
  },
};
</script>

<style lang="scss">
@import "../../theme";

.admin-dashboard {
  content {
    margin-top: 50px;
    margin-bottom: 50px;
    display: block;

    h1 {
      text-align: center;
      text-transform: uppercase;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 0;
    }

    p {
      text-align: center;
    }
  }

  section {
    text-align: center;

    .col {
      margin-top: 20px;
    }

    i {
      font-size: 35px;
      color: $theme-color;
    }

    h4 {
      font-size: 25px;
      text-transform: uppercase;
      font-weight: bold;
      margin-top: 10px;

      small {
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard.vue